import getTermsConditionsSaga from './getTermsConditions';

export const packageSagas = [getTermsConditionsSaga];
